import { createSelector } from 'reselect'

export const getCountries = createSelector(
  (state) => state.geoObjects && state.geoObjects.countries && state.geoObjects.countries.elements
    ? state.geoObjects.countries.elements
    : [],
  (countries) => countries
)
